import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const SupDashboardContentStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  height: 100%;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.colors.grey[100]};
`;

export const SupDashboardStatStyled = styled(Box).attrs({
  mb: { sm: '500' },
  px: { sm: '600' },
  pt: { sm: '500' },
  pb: { sm: '100' },
})`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacings[600]};
    & > :not(:last-child) {
      margin-right: ${theme.spacings[600]};
    }
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      margin-bottom: ${theme.spacings[500]};
      & > :not(:last-child) {
        margin-right: ${theme.spacings[500]};
      }
    }
    @media only screen and (max-width: ${theme.breakpoints.desktop}) {
      & > :not(:last-child) {
        margin-right: ${theme.spacings[400]};
      }
    }
  `}
`;

export const SectionListStyled = styled(Box).attrs({ pb: { sm: '300' }, px: { sm: '600' } })`
  height: 100%;
  overflow-y: auto;
`;

export const DashBoardLeftSectionStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: 100%;
`;

export const WorkPackageContainerStyled = styled(Box)`
  margin-right: ${({ theme }) => theme.spacings[600]};
  width: 36.4%;
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    margin-right: ${({ theme }) => theme.spacings[500]};
    width: 37%;
  }
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: 45%;
    margin-right: ${({ theme }) => theme.spacings[400]};
  }
`;

export const WeeklyWorkListContainerStyled = styled(Box)`
  width: 63.6%;
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    width: 63%;
  }
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: 55%;
  }
`;
